module.exports = __webpack_public_path__ + "static/media/img_7.7318fc03.png";